<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="项目" prop="project_id">
                            <Select v-model="Forms.project_id" :disabled="is_select" clearable filterable  placeholder="项目" @on-change="getCustomerId">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}}({{item.status_name}})</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="收款类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="收款类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请人" prop="apply_id">
                            <Select v-model="Forms.apply_id" clearable filterable  placeholder="申请人">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="不含税金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="" @on-blur="calcTrueMoney" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="费率" prop="tax_rate">
                            <Input v-model="Forms.tax_rate" type="number" @on-blur="calcTaxMoney" clearable placeholder="0~100" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税费" prop="tax_money">
                            <Input v-model="Forms.tax_money" @on-blur="calcTrueMoney" type="number" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="含税金额" prop="true_money">
                            <Input v-model="Forms.true_money" type="number" clearable placeholder="" @on-blur="calcMoney" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="收款账户" prop="get_bank">
                            <Select v-model="Forms.get_bank" clearable filterable  placeholder="收款账户" class="width-100">
                                <Option v-for="(item,index) in bankList" :key="index" :value="item.id">{{item.account}}({{item.company}}{{ item.bank }})</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="计划收款">
                            <RadioGroup v-model="Forms.is_plan" type="button" button-style="solid">
                                <Radio :label="1">是</Radio>
                                <Radio :label="0">否</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="Forms.is_plan == 1">
                        <FormItem label="收款时间" prop="plan_time" :rules="[{required: true, type:'date', message: '请输入收款时间', trigger: 'change'}]">
                            <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.plan_time" placeholder="收款时间" class="width-100"  />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="是否开发票">
                            <RadioGroup v-model="Forms.is_invoice" type="button" button-style="solid">
                                <Radio :label="2">需要</Radio>
                                <Radio :label="1">不需要</Radio>
                            </RadioGroup>
                            <span v-if="Forms.is_invoice == 2">&nbsp;<Button type="primary"  ghost @click="getContact">自动获取发票信息</Button></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32"  v-if="Forms.is_invoice == 2">
                    <Col span="12">
                        <FormItem label="发票抬头" prop="inv_head">
                            <Input v-model="Forms.inv_head" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票税号" prop="inv_num">
                            <Input v-model="Forms.inv_num" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="inv_phone">
                            <Input v-model="Forms.inv_phone" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="inv_bank">
                            <Input v-model="Forms.inv_bank" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="银行卡号" prop="inv_bank_card">
                            <Input v-model="Forms.inv_bank_card" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票地址" prop="inv_address">
                            <Input v-model="Forms.inv_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="收款备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getIncomeConfig, getIncomeDetail, saveIncome} from "@/apis/income";
import {getCustomerInvoice} from "@/apis/customer";
import {getProjectCustomerId} from "@/apis/project";

export default {
    name: 'IncomeCollection',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目收款',
            isBox : false,
            typeList: [],
            projectList: [],
            customerList: [],
            userList: [],
            bankList: [],
            is_select: false,

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                id: '',
                project_id: '',
                customer_id: '',
                type_id: '',
                apply_id: '',
                money: '',
                tax_rate: '',
                tax_money: '',
                true_money: '',
                get_bank: '',
                is_plan: 0,
                plan_time: '',
                is_invoice: 1,
                inv_head: '',
                inv_num: '',
                inv_phone: '',
                inv_bank: '',
                inv_bank_card: '',
                inv_address: '',
                remark: ''
            },
            Rules : {
                project_id: [
                    { required: true, type: 'number',  message: '请选择项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择收款类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                apply_id: [
                    { required: true, type: 'number',  message: '请选择申请人', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入收款金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                true_money: [
                    { required: true, type: 'number',  message: '请输入实收金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ]
            }
        }
    },
    methods: {
        /**
         功能：
         time: 2026/1/6 16:46
         **/
        getCustomerId(e){
            let that = this;
            if(!e){
                // that.$Message.error({ background: true,duration:3, content: '请选择项目'});
                return;
            }
            getProjectCustomerId(e).then(e => {
                that.Forms.customer_id = e.data ?? 0;
            })
        },
        /**
         功能：
         time: 2025/12/26 16:14
         **/
        getContact(){
            let that = this;
            if(!that.Forms.customer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择项目'});
                return;
            }
            getCustomerInvoice(that.Forms.customer_id).then(e => {
                let data = e.data;
                that.Forms.inv_head = data.inv_head ?? '';
                that.Forms.inv_num = data.inv_num ?? '';
                that.Forms.inv_phone = data.inv_phone ?? '';
                that.Forms.inv_bank = data.inv_bank ?? '';
                that.Forms.inv_bank_card = data.inv_bank_card ?? '';
                that.Forms.inv_address = data.inv_address ?? '';
            })
        },
        /**
         * 功能：金额保留两位小数
         * time: 2026/10/06
         **/
        roundMoney(num){
            return Math.round((num + Number.EPSILON) * 100) / 100;
        },
        /**
         * 功能：计算税费（不含税金额 + 费率 => 税费、含税金额；含税金额 + 费率 => 不含税金额、税费）
         * time: 2025/12/25 17:29
         **/
        calcTaxMoney(){
            let that = this;
            let money = parseFloat(that.Forms.money);
            let true_money = parseFloat(that.Forms.true_money);
            let tax_rate = parseFloat(that.Forms.tax_rate);
            if(isNaN(tax_rate)) return;
            if(!isNaN(money)){
                that.Forms.tax_money = that.roundMoney(money * tax_rate / 100);
                that.calcTrueMoney();
            }else if(!isNaN(true_money)){
                that.calcMoney();
            }
        },
        /**
         * 功能：计算实收金额（不含税金额 + 税费 => 含税金额）
         * time: 2025/12/25 17:29
         **/
        calcTrueMoney(){
            let that = this;
            let money = parseFloat(that.Forms.money);
            let tax_money = parseFloat(that.Forms.tax_money);
            if(isNaN(money) || isNaN(tax_money)) return;
            that.Forms.true_money = that.roundMoney(money + tax_money);
        },
        /**
         * 功能：计算不含税金额（含税金额 + 费率 => 不含税金额、税费）
         * time: 2026/10/06
         **/
        calcMoney(){
            let that = this;
            let true_money = parseFloat(that.Forms.true_money);
            let tax_rate = parseFloat(that.Forms.tax_rate);
            if(isNaN(true_money) || isNaN(tax_rate)) return;
            let money = that.roundMoney(true_money / (1 + tax_rate / 100));
            that.Forms.money = money;
            that.Forms.tax_money = that.roundMoney(true_money - money);
        },
      




        /**
         功能：获取配置
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getIncomeConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.projectList = e.data.projectList ?? [];
                that.bankList = e.data.bankList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/25 18:19
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getIncomeDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'project_id' || v === 'customer_id' || v === 'type_id'  || v === 'apply_id' || v === 'get_bank' || v === 'is_plan') {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2025/12/25 18:19
         **/
        edit(id){
            this.isBox = true;
            this.is_select = true;
            this.GetConfig();
            if(id) this.GetDetail(id);
        },
        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveIncome(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },

        FormReset(){
            this.isBox = false;
            this.title = '项目收款';
            this.$refs['Forms'].resetFields();
            this.Forms.typeList = [];
            this.Forms.projectList = [];
            this.Forms.customerList = [];
            this.Forms.userList = [];
            this.Forms.bankList = [];
            this.is_select = false;
            this.Forms.id = '';
            this.Forms.customer_id = '';
            this.Forms.is_plan = 0;
            this.Forms.is_invoice = 1;
            this.Forms.inv_head = '';
            this.Forms.inv_num = '';
            this.Forms.inv_phone = '';
            this.Forms.inv_bank = '';
            this.Forms.inv_bank_card = '';
            this.Forms.inv_address = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
